<template>
  <button class="close" @click="handleClick">&times;</button>
</template>

<script>
export default {
  name: 'CloseButton',
  methods: {
    handleClick() {
      this.$emit('closed')
    }
  }
}
</script>

<style lang="scss" scoped>
.close {
  font-size: 16px;
  padding: 10px;
}
</style>
